import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as manager from './ManagerRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({manager: state.manager})
const connector = connect(mapState, manager.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const ManagerInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(ManagerInit)
